import { useRef, useEffect, useState } from "react";
import { CancelToken } from "axios";

export const useGetData = ({ apiCall, deps = [], cancelOnUnmount }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refRanOnce = useRef(false);
  const refDeps = useRef(deps);
  const cancelCall = useRef();

  useEffect(() => {
    cancelCall.current = CancelToken.source();

    const depsChanged =
      JSON.stringify(refDeps.current) !== JSON.stringify(deps);

    if (!refRanOnce.current || depsChanged) {
      refRanOnce.current = true;
      refDeps.current = deps;

      setLoading(true);
      apiCall({
        options: { cancelToken: cancelCall.current.token }
      })
        .then(results => {
          setData(results.data);
        })
        .catch(error => {
          if (error.code !== "ERR_CANCELED") console.error(error);
          setError(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [deps, apiCall]);

  /* on unmount, cancel the request */
  useEffect(() => {
    if (cancelOnUnmount && cancelCall?.current)
      return () => cancelCall.current.cancel("Request cancelled");
  }, [cancelCall, cancelOnUnmount]);

  return { data, loading, error, cancelCall: cancelCall.current };
};
